import { ChangeDetectorRef, Component, Input, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid'
import frLocale from '@fullcalendar/core/locales/fr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalName } from '../../../core/utils/global-name';
import { LocalStorageService } from '../../../core/utils/local-stoarge-service';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CommonModule } from '@angular/common';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
    selector: 'app-simple-calendar',
    templateUrl: './simple-calendar.component.html',
    imports: [CommonModule, FullCalendarModule, NgxExtendedPdfViewerModule],
    styleUrls: ['./simple-calendar.component.css']
})
export class SimpleCalendarComponent {
  @ViewChild('showContent') showContent:TemplateRef <any>| undefined
  @Input('data') data:any=[];  
  obj:any
  events:any=[];    
  calendarOptions: CalendarOptions ={};
  cycles:any[]=[]
  role:any
  user:any
  constructor(
    private cd: ChangeDetectorRef,
    private lsService:LocalStorageService,
    private modalService: NgbModal){
    
  }

  ngOnInit(){
    this.user=this.lsService.get(GlobalName.userName)
    this.cycles=this.lsService.get(GlobalName.features).cycles

    let verifyCycle=this.user?.professor?.cycles.filter((el:any)=> el.tag == this.cycles[0] || el.tag == this.cycles[1] || el.tag == this.cycles[2])
    let verifyCycle2=this.user?.cycles.filter((el:any)=> el.tag == this.cycles[0] || el.tag == this.cycles[1] || el.tag == this.cycles[2])
   
    if (verifyCycle?.length !=0 || verifyCycle2?.length!=0 ) {
      this.calendarOptions= {
        eventClick:(info:any) =>this.showCard(info),
        locale: frLocale, 
        slotMinTime: '07:00:00',
        slotMaxTime: '14:00:00',
        //initialView: 'dayGridMonth',
        initialView: 'timeGridWeek',
        weekends: false,
       // plugins: [dayGridPlugin],
        plugins: [timeGridPlugin],
        headerToolbar: {
          left: 'prev,next',
          center: 'title',
          right: 'timeGridWeek,timeGridDay' // user can switch between the two
        },
        contentHeight:'600px',

      }
    }else{
      this.calendarOptions= {
        eventClick:(info:any) =>this.showCard(info),
        locale: frLocale, 
        slotMinTime: '07:00:00',
        slotMaxTime: '19:00:00',
        //initialView: 'dayGridMonth',
        initialView: 'timeGridWeek',
        weekends: false,
       // plugins: [dayGridPlugin],
        plugins: [timeGridPlugin],
        headerToolbar: {
          left: 'prev,next',
          center: 'title',
          right: 'timeGridWeek,timeGridDay' // user can switch between the two
        },
        
      }
    
    }
 
  }

  ngOnChanges(changes: SimpleChanges){

    this.events=[];
    changes['data'].currentValue.forEach((element:any) => {
        console.log(element.name==undefined)
      let title=element.name==null || element.name==undefined ?
                             `${element.course}`
                             : `${element.name}`
      this.events.push({
        id:element.id,
        title:title,
       // title: `${element.date_name} | ${element.course} | ${element.classroom}  | ${element.professor}`,
        color:element.color,
        start: new Date(`${element.date}T${element.start}`),
        end: new Date(`${element.date}T${element.end}`) 
      })
    });

    this.calendarOptions.events=this.events
    //this.cd.detectChanges();
    console.log(changes)  
  }

  showCard(ev:any){
    this.obj=ev.event
    this.modalService.open(this.showContent)
    console.log(this.obj)
  }
}
